import React, {useEffect, useState} from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import PropTypes from 'prop-types';
import Switch from '@material-ui/core/Switch';
import TextField from '@material-ui/core/TextField';
import Tooltip from '@material-ui/core/Tooltip';
import {Link} from "react-router-dom";

const initialUser = {
    policyNumber: '',
    policyType: '',
    paymentChannel: '',
    paymentMethod: '',
    baseCurrency: '',
    paymentReference: '',
    billedAmount: '',
    receivedAmount: '',
    paymentDate: '',


}

const AddUserDialog = props => {
    const [user, setUser] = useState(initialUser)
    const {addUserHandler} = props
    const [open, setOpen] = React.useState(false)
    const [paymentButton, setPaymentButton] = useState(false)

    useEffect(() => {
        let role_based_perm = JSON.parse(localStorage.getItem('role_based_permissions'));
        let direct_perm = JSON.parse(localStorage.getItem('direct_permissions'));
        console.log("role_based: ", role_based_perm);
        console.log("direct perm: ", direct_perm);
        if (role_based_perm === null || role_based_perm === undefined) {
            setPaymentButton(false);
        } else {
            role_based_perm.map((perm, i) => {
                if (perm.name === 'make payments') {
                    setPaymentButton(true);
                }
            })
        }
        if (direct_perm === null || direct_perm === undefined) {
            setPaymentButton(false);
        } else {
            direct_perm.map((perm, i) => {
                if (perm.name === 'make payments') {
                    setPaymentButton(true);
                }
            })
        }
    }, [])


    const [switchState, setSwitchState] = React.useState({
        addMultiple: false,
    })

    const handleSwitchChange = name => event => {
        setSwitchState({...switchState, [name]: event.target.checked})
    }

    const resetSwitch = () => {
        setSwitchState({addMultiple: false})
    }

    const handleClickOpen = () => {
        // console.log("emp id:", props.data.id);
        setOpen(true)
    }

    const handleClose = () => {
        setOpen(false)
        resetSwitch()
    }

    const handleAdd = event => {
        addUserHandler(user)
        setUser(initialUser)
        switchState.addMultiple ? setOpen(true) : setOpen(false)
    }


    const handleChange = name => ({target: {value}}) => {
        setUser({...user, [name]: value})
    }


    return (
        <div>
            {paymentButton && (
                <div className="row justify-content-between">
                    <div className="col-md-4">
                        <Tooltip title="Add New Receipt">
                            <Link to={'/add-payment'}>
                            <span className="btn btn-sm btn-primary mr-5">
                    <i className="fa fa-money"/> &nbsp;&nbsp;New Receipt
                </span>
                            </Link>
                        </Tooltip>
                    </div>
                    <div className="col-md-4">
                        <Tooltip title="Add Bulk Receipt">
                            <Link to={'/bulk-payments'}>
                            <span className="btn btn-sm btn-primary mr-5">
                    <i className="fa fa-cloud-upload"/> &nbsp;
                                &nbsp;Make Bulk Receipt
                </span>
                            </Link>
                        </Tooltip>
                    </div>
                </div>
            )}


            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="form-dialog-title"
            >
                <DialogTitle id="form-dialog-title">Add Receipt</DialogTitle>
                <DialogContent>
                    <DialogContentText>Please fill in details</DialogContentText>
                    <div className="row">
                        <div className="col-4">
                            <TextField
                                autoFocus
                                margin="dense"
                                label="Policy No"
                                type="text"
                                fullWidth
                                value={user.policyNumber}
                                onChange={handleChange('policyNumber')}
                            />
                        </div>

                        <div className="col-4">
                            <select className="form-control" onChange={handleChange('policyType')} name="policyType"
                            >

                                <option disabled>Policy Type</option>
                                <option value="SAVINGS">SAVINGS</option>
                                <option value="COMPREHENSIVE">COMPREHENSIVE</option>
                                <option value="FUNERAL">FUNERAL</option>
                                <option value="ACCIDENT">ACCIDENT</option>

                            </select>


                        </div>

                        <div className="col-4">


                            <select className="form-control" onChange={handleChange('paymentChannel')}
                                    name="paymentChannel">
                                <option disabled>Payment Channel</option>
                                <option value="CASH">Cash</option>
                                <option value="ECOCASH">Ecocash</option>
                                <option value="ONEMONEY">One Money</option>
                                <option value="TELECASH">Telecash</option>
                                <option value="RTGS">RTGS</option>
                                <option value="ZIPIT">ZIPIT</option>


                            </select>

                        </div>

                        <div className="col-4">


                            <select className="form-control" onChange={handleChange('paymentMethod')}
                                    name="paymentMethod">
                                <option disabled>Payment Method</option>
                                <option value="CASH">Cash</option>
                                <option value="STOP_ORDER">Stop Order</option>
                                <option value="DEBIT_ORDER">Debit Order</option>
                            </select>


                        </div>
                        <div className="col-4">


                            <select className="form-control" onChange={handleChange('baseCurrency')}
                                    name="baseCurrency">
                                <option disabled>Base Currency</option>
                                <option value="ZWL">ZWL</option>
                                <option value="USD">USD</option>
                                <option value="NOSTRO">Nostro</option>

                            </select>


                        </div>
                        <div className="col-4">
                            <TextField
                                margin="dense"
                                label="Payment Reference"
                                type="text"
                                fullWidth
                                value={user.paymentReference}
                                onChange={handleChange('paymentReference')}
                            />


                        </div>
                        <div className="col-4">

                            <TextField
                                margin="dense"
                                label="Biiled Amount"
                                type="text"
                                fullWidth
                                value={user.billedAmount}
                                onChange={handleChange('billedAmount')}
                            />

                        </div>
                        <div className="col-4">
                            <TextField
                                margin="dense"
                                label="Received Amount"
                                type="text"
                                fullWidth
                                value={user.receivedAmount}
                                onChange={handleChange('receivedAmount')}

                            />

                        </div>
                        <div className="col-4">
                            <TextField
                                margin="dense"
                                label="."
                                type="date"
                                fullWidth
                                value={user.paymentDate}
                                onChange={handleChange('paymentDate')}
                            />

                        </div>


                    </div>


                </DialogContent>
                <DialogActions>
                    <Tooltip title="Add multiple">
                        <Switch
                            checked={switchState.addMultiple}
                            onChange={handleSwitchChange('addMultiple')}
                            value="addMultiple"
                            inputProps={{'aria-label': 'secondary checkbox'}}
                        />
                    </Tooltip>
                    <Button onClick={handleClose} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={handleAdd} color="primary">
                        Add
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

AddUserDialog.propTypes = {
    addUserHandler: PropTypes.func.isRequired,
}

export default AddUserDialog;
